import { toPublicUrl } from "../../services/PublicUrl";
import { useTranslation } from "react-i18next";
import "./ImplementationGuidePage.css";

export default function ImplementationGuidePage() {
  const { t } = useTranslation();
  return (
    <main className="implementation-guide-page">
      <iframe
        className="implementation-guide-page__frame"
        src={toPublicUrl("/ig/index.html")}
        title={t("a11y.implementationGuide")}
      />
    </main>
  );
}
